<ng-container id="üstMenü">
  <div *ngIf="visible" style="font-size: 18px">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      <b>
        <ng-container>Buluş Adı: {{ inventionName }}</ng-container></b
      >
    </ng-container>
  </div>
  <div *ngIf="visible">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      Dosya No:{{ item.documentNumber }}
    </ng-container>
  </div>
  <div *ngIf="visible">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      Dosya Durumu: {{ item.status[item.status.length - 1].status }}
    </ng-container>
  </div>
</ng-container>
<div>
  <button class="btn" (click)="navigate()">Üst Menüye Git</button>
</div>
<br />

<p></p>
<div>
  <button class="btn" (click)="openPriority()">
    İlk Patent Kaydını (Rüçhan) Ekle
  </button>

  <button class="btn" *ngIf="isPatentExists" (click)="openEnterance()">
    Ek Ülke kaydı Ekle
  </button>
</div>
<h2 *ngIf="isRecorded" id="buluş">Kayıt Yapıldı.</h2>
<span></span>
<br />
<div class="form-group col-md-12" id="buluş" *ngIf="visiblePriorty">
  <h3>Yeni İlk Ülke Girişi (Rüçhan) Kaydı:</h3>
  <hr />
  <table>
    <tr>
      <td>
        <label for="inventionType">Buluş Türü:</label>
      </td>
      <td>
        <input
          type="radio"
          id="user"
          name="inventionType"
          value="incelemeli patent"
          [(ngModel)]="inventionType"
        />

        <label for="inventionType">İncelemeli Patent</label>
      </td>

      <td>
        <input
          type="radio"
          id="user"
          name="inventionType"
          value="incelemesiz patent"
          [(ngModel)]="inventionType"
        />
        <label for="inventionType">İncelemesiz Patent</label>
      </td>
      <td>
        <input
          type="radio"
          id="user"
          name="inventionType"
          value="faydalı model (araştırma raporlu)"
          [(ngModel)]="inventionType"
        />
        <label for="inventionType">Faydalı Model (Araştırma Raporlu)</label>
      </td>
      <td>
        <input
          type="radio"
          id="user"
          name="inventionType"
          value="faydalı model (araştırma raporsuz)"
          [(ngModel)]="inventionType"
        />
        <label for="user">Faydalı Model (Araştırma Raporsuz)</label>
      </td>
    </tr>
  </table>
  <table>
    <tr>
      <td>
        <label for="priorityName">Buluşun İlgili Ülkedeki Adı:</label>
      </td>
      <td>
        <textarea
          rows="1"
          cols="150"
          [(ngModel)]="priorityName"
          (ngModelChange)="priorityName = $event.toLowerCase()"
          type="text"
          id="priorityName"
          placeholder="{{ priorityName }}"
        >
        </textarea>
      </td>
    </tr>

    <tr>
      <td>
        <label for="priorityNumber">İlk Patent (Rüçhan) No:</label>
      </td>
      <td>
        <textarea
          [(ngModel)]="priorityNumber"
          (ngModelChange)="priorityNumber = $event.toLowerCase()"
          rows="1"
          cols="150"
          type="text"
          id="priorityNumber"
          placeholder="{{ priorityNumber }}"
        ></textarea>
      </td>
    </tr>

    <tr>
      <td>
        <label for="priorityNumber">İlk Patent (Rüçhan) Tarihi:</label>
      </td>
      <td>
        <input
          [(ngModel)]="priorityDate"
          type="date"
          id="priorityDate"
          placeholder="{{ priorityDate }}"
        />
      </td>
    </tr>
    <tr>
      <td>
        <label for="abstract">Buluş Özeti</label>
      </td>
      <td>
        <textarea
          [(ngModel)]="abstract"
          (ngModelChange)="abstract = $event.toLowerCase()"
          rows="3"
          cols="150"
          type="text"
          id="abstract"
          placeholder="{{ abstract }}"
        ></textarea>
      </td>
    </tr>
    <tr>
      <td>
        <label for="title">1.İstem</label>
      </td>
      <td>
        <textarea
          [(ngModel)]="firstClaim"
          (ngModelChange)="firstClaim = $event.toLowerCase()"
          rows="10"
          cols="150"
          type="text"
          id="title"
          name="title"
          placeholder="{{ firstClaim }}"
        ></textarea>
      </td>
    </tr>
    <tr>
      <td>
        <label for="title">Notlar</label>
      </td>
      <td>
        <textarea
          [(ngModel)]="countryNote"
          (ngModelChange)="countryNote = $event.toLowerCase()"
          rows="5"
          cols="150"
          type="text"
          id="title"
          name="title"
          placeholder="{{ countryNote }}"
        ></textarea>
      </td>
    </tr>
  </table>

  <table>
    <tr>
      <td>
        <label for="priorityCountry">İlk Başvuru Ülkesi:</label>
        <select
          name="priorityCountry"
          [(ngModel)]="priorityCountry"
          id="priorityCountry"
        >
          <option value="türkiye (tr)">Türkiye (TR)</option>
          <option value="pct (wipo)(pct)">PCT (WIPO)(PCT)</option>
          <option value="avrupa (epo)(ep)">Avrupa Patenti (EPO)(EP)</option>
          <option value="körfez işbirliği sözleşmesi (gcc)">
            Körfez İşbirliği Sözleşmesi (GCC)
          </option>
          <option value="avrasya patent sözleşmesi (eurasian)">
            Avrasya Patent Sözleşmesi (EURASIAN)
          </option>
          <option value="afrika fikri mülkiyet örgütü (oapi)">
            Afrika Fikri Mülkiyet Örgütü (OAPI)
          </option>
          <option value="afrika fikri mülkiyet örgütü (aripo)">
            Afrika Fikri Mülkiyet Örgütü (ARIPO)
          </option>
          <option value="amerika (us)">Amerika (US)</option>
          <option value="birleşik arap emirlikleri (bae)">
            Birleşik Arap Emirikleri (BAE)
          </option>
          <option value="antigua ve barbuda (ag)">
            Antigua ve Barbuda (AG)
          </option>
          <option value="arnavutluk (al)">Arnavutluk (AL)</option>
          <option value="ermenistan (am)">Ermenistan (AM)</option>
          <option value="angola (ao)">Angola (AO)</option>
          <option value="avusturya (at)">Avusturya (AT)</option>
          <option value="azerbeycan/azerbaycan (az)">Azerbeycan (AZ)</option>
          <option value="saraybosna/bosnahersek (ba)">SarayBosna (BA)</option>
          <option value="barbados (bb)">Barbados (BB)</option>
          <option value="belçika (be)">Belçika (BE)</option>
          <option value="burkina faso (BF)">Burkina Faso (BF)</option>
          <option value="bulgaristan (bg)">Bulgaristan (BG)</option>
          <option value="bahreyn (be)">Bahreyn (BE)</option>
          <option value="benin (bj)">Benin (BJ)</option>
          <option value="brezilya (br)">Brezilya (BR)</option>
          <option value="botsvana/botswana (bw)">Botsvana (BW)</option>
          <option value="belarus (by)">Belarus (BY)</option>
          <option value="belize (bz)">Belize (BZ)</option>
          <option value="kanada (ca)">Kanada (CA)</option>
          <option value="orta afrika cumhuriyeti (cf)">
            Orta Afrika Cumhuriyeti (CF)
          </option>
          <option value="isviçre (ch)">İsviçre (CH)</option>
          <option value="fildişi sahili (ci)">Fildişi Sahili (CI)</option>
          <option value="şili (cl)">Şili (CL)</option>
          <option value="kamerun (CM)">Kamerun (CM)</option>
          <option value="çin (cn)">Çin (CN)</option>
          <option value="kolombiya (co)">Kolombiya (CO)</option>
          <option value="kosta rika/kostarika (cr)">Kosta Rika (CR)</option>
          <option value="küba (cu)">Küba (CU)</option>
          <option value="kıbrıs (cy)">Kıbrıs (CY)</option>
          <option value="çek cumhuriyeti (cz)">Çek Cumhuriyeti (CZ)</option>
          <option value="almanya (de)">Almanya (DE)</option>
          <option value="cibuti (dj)">Cibuti (DJ)</option>
          <option value="danimarka (da)">Danimarka (DA)</option>
          <option value="dominik (dm)">Dominik (DM)</option>
          <option value="dominik cumhuriyeti (do)">
            Dominik Cumhuriyeti (DO)
          </option>
          <option value="cezayir (dz)">Cezayir (DZ)</option>
          <option value="ekvator (ec)">Ekvator (EC)</option>
          <option value="estonya (ee)">Estonya (EE)</option>
          <option value="mısır (eg)">Mısır (EG)</option>
          <option value="ispanya (es)">İspanya (ES)</option>
          <option value="finlandiya (fi)">Finlandiya (FI)</option>
          <option value="fransa (fr)">Fransa (FR)</option>
          <option value="gabon (ga)">Gabon (GA)</option>
          <option value="ingiltere krallığı (gb)">İngiltere (GB)</option>
          <option value="grenada (gd)">Grenada (GD)</option>
          <option value="Gürcistan (ge)">Gürcistan (GE)</option>
          <option value="gana (gh)">Gana (GH)</option>
          <option value="gambiya (gm)">Gambiya (GM)</option>
          <option value="gine (gn)">Gine (GN)</option>
          <option value="yunanistan (gr)">Yunanistan (GR)</option>
          <option value="guatemala (gn)">Guatemala (GN)</option>
          <option value="honduras (hn)">Honduras (HN)</option>
          <option value="hırvatistan (hr)">Hırvatistan (HR)</option>
          <option value="macaristan (hu)">Macaristan (hu)</option>
          <option value="endonezya (id)">Endonezya (ID)</option>
          <option value="irlanda (ie)">İrlanda (IE)</option>
          <option value="israil (il)">İsrail (IL)</option>
          <option value="hindistan (ie)">Hindistan (IE)</option>
          <option value="ırak (iq)">Irak (IQ)</option>
          <option value="iran (ir)">İran (IR)</option>
          <option value="izlanda (is)">İzlanda (IS)</option>
          <option value="italya (it)">İtalya (IT)</option>
          <option value="jamaika (jm)">Jamaika (JM)</option>
          <option value="ürdün (jo)">Ürdün (JO)</option>
          <option value="japonya (jp)">Japonya (JP)</option>
          <option value="kenya (ke)">Kenya (KE)</option>
          <option value="kırgizistan (kg)">Kırgızistan (KG)</option>
          <option value="kamboçya (kh)">Kamboçya (KH)</option>
          <option value="güney kore (kr)">Güney Kore (KR)</option>
          <option value="kuveyt (kw)">Kuveyt (KW)</option>
          <option value="kazakistan (kz)">Kazakistan (KZ)</option>
          <option value="lübnan (lb)">Lübnan (LB)</option>
          <option value="lihtenştayn (li)">Lihtenştayn (LI)</option>
          <option value="sri lanka/srilanka (lr)">Sri Lanka (LR)</option>
          <option value="liberya (lr)">Liberya (LR)</option>
          <option value="lesotho (ls)">Lesotho (LS)</option>
          <option value="litvanya (lt)">Litvanya (LT)</option>
          <option value="lüksemburg (lu)">Lüksemburg (LU)</option>
          <option value="letonya (lv)">Letonya (LV)</option>
          <option value="libya (ly)">Libya (LY)</option>
          <option value="fas (ma)">Fas (MA)</option>
          <option value="monaco (mc)">Monaco (MC)</option>
          <option value="moldova (md)">Moldova (MD)</option>
          <option value="karadağ (me)">Karadağ (ME)</option>
          <option value="madagaskar (md)">Madagaskar (MD)</option>
          <option value="makedonya (mk)">Makedonya (MK)</option>
          <option value="mali (me)">Mali (ME)</option>
          <option value="moğolistan (mn)">Moğolistan (MN)</option>
          <option value="moritanya (mr)">Moritanya (MR)</option>
          <option value="malta (mt)">Malta (MT)</option>
          <option value="meksika (mx)">Meksika (MX)</option>
          <option value="malezya (me)">Malezya (ME)</option>
          <option value="mozambik (mz)">Mozambik (MZ)</option>
          <option value="namibya (na)">Namibya (NA)</option>
          <option value="nijer (ne)">Nijer (NE)</option>
          <option value="nijerya (ng)">Nijerya (NG)</option>
          <option value="nikeragua (ni)">Nikeragua (NI)</option>
          <option value="hollanda (nl)">Hollanda (NL)</option>
          <option value="norveç (no)">Norveç (NO)</option>
          <option value="yeni zelanda (nz)">Yeni Zelanda (NZ)</option>
          <option value="umman (om)">Umman (OM)</option>
          <option value="panama (pa)">Panama (PA)</option>
          <option value="peru (pe)">Peru (PE)</option>
          <option value="papua yeni gine (pg)">Papua Yeni Gine (PG)</option>
          <option value="filipinler (PH)">Filipinler (PH)</option>
          <option value="polonya (pl)">Polonya (PL)</option>
          <option value="portekiz (pt)">Portekiz (PT)</option>
          <option value="katar (qa)">Katar (QA)</option>
          <option value="romanya (ro)">Romanya (RO)</option>
          <option value="sırbistan (rs)">Sırbistan (RS)</option>
          <option value="rusya (ru)">Rusya (RU)</option>
          <option value="suudi arabistan (sa)">Suudi Arabistan (SA)</option>
          <option value="sudan (sd)">Sudan (SD)</option>
          <option value="isveç (se)">İsveç (SE)</option>
          <option value="singapur (sg)">Singapur (SG)</option>
          <option value="slovenya (si)">Slovenya (SI)</option>
          <option value="slovakya (sk)">Slovakya (SK)</option>
          <option value="san marino (sm)">San Marino (SM)</option>
          <option value="senegal (sn)">Senegal (SN)</option>
          <option value="el salvador/elsalvador (sv)">El Salvador (SV)</option>
          <option value="suriye (sy)">Suriye (SY)</option>
          <option value="çad (td)">Çad (TD)</option>
          <option value="togo (tg)">Togo (TG)</option>
          <option value="tayland (th)">Tayland (TH)</option>
          <option value="tacikistan (tj)">Tacikistan (TJ)</option>
          <option value="türkmenistan (tm)">Türkmenistan (TM)</option>
          <option value="tunus (tn)">Tunus (TN)</option>
          <option value="trinidad ve tobago (tt)">
            Trinidad ve Tobago (TT)
          </option>
          <option value="tanzanya (tz)">Tanzanya (TZ)</option>
          <option value="ukrayna (ua)">Ukrayna (UA)</option>
          <option value="angola (ao)">Uganda (UG)</option>
          <option value="amerika (us)">Amerika (US)</option>
          <option value="özbekistan (uz)">Özbekistan (UZ)</option>
          <option value="vietnam (vn)">Vietnam (VN)</option>
          <option value="güney afrika (za)">Güney Afrika (ZA)</option>
          <option value="zambiya (zm)">Zambiya (ZM)</option>
          <option value="zimbabve (zw)">Zimbabve (ZW)</option>
        </select>
      </td>

      <!-- <td>
        <input
          type="radio"
          id="user"
          name="user"
          value="Türkiye"
          [(ngModel)]="priorityCountry"
        />

        <label for="user">Türkiye (TR)</label>
      </td>

      <td>
        <input
          type="radio"
          id="user"
          name="user"
          value="PCT Başvurusu"
          [(ngModel)]="priorityCountry"
        />
        <label for="user">WIPO/PCT (WO)</label>
      </td>
      <td>
        <input
          type="radio"
          id="user"
          name="user"
          value="Avrupa Patenti / EPO"
          [(ngModel)]="priorityCountry"
        />
        <label for="user">EPO (EP)</label>
      </td>
      <td>
        <button class="btn btn-warning" (click)="showCountries()">
          Ülkem farklı
        </button>
        <ng-container *ngIf="visibleCountryList">
          <input type="text" [(ngModel)]="priorityCountry" />
        </ng-container>
      </td> -->
    </tr>
  </table>

  <button
    [disabled]="
      priorityCountry === 'Ülke Seçilmedi' ||
      priorityNumber == '' ||
      priorityName == '' ||
      priorityDate == '' ||
      inventionType == ''
    "
    class="btn"
    (click)="recordPriority()"
    style="
      margin-left: auto;
      margin-right: 10%;
      font-size: 18px;
      display: block;
      background-color: #28384f;
    "
  >
    İlk Patenti Kaydet
  </button>
</div>

<div class="form-group col-md-12" id="buluş" *ngIf="visibleEntrence">
  <div *ngIf="!priorityExists">
    <h2>Kaydedilecek Ülke Girişinin Bağlı Olduğu Rüçhanı Seçin</h2>
    <br />
    <div class="form-row" id="inventors">
      <div *ngFor="let patents of patentInfo; let i = index">
        <div
          *ngIf="
            patents.priority.includes('Rüçhan') ||
            patents.patentCountry.includes('pct') ||
            patents.patentCountry.includes('avrupa')
          "
        >
          <button
            type="button"
            (click)="
              inventorsPriority(
                patents.patentType,
                patents.patentCountry,
                patents.patentNumber
              )
            "
          >
            {{ patents.patentCountry }}/{{ patents.patentType }}/{{
              patents.patentNumber
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="priorityExists">
    <h3>Yeni Ülke Girişi Kaydı:</h3>
    <hr />
    <table>
      <tr>
        <td>
          <label for="inventionType">Buluş Türü:</label>
        </td>
        <td>
          <input
            type="radio"
            id="user"
            name="inventionType"
            value="incelemeli patent"
            [(ngModel)]="inventionType"
          />

          <label for="inventionType">İncelemeli Patent</label>
        </td>

        <td>
          <input
            type="radio"
            id="user"
            name="inventionType"
            value="incelemesiz patent"
            [(ngModel)]="inventionType"
          />
          <label for="inventionType">İncelemesiz Patent</label>
        </td>
        <td>
          <input
            type="radio"
            id="user"
            name="inventionType"
            value="faydalı model (araştırma raporlu)"
            [(ngModel)]="inventionType"
          />
          <label for="inventionType">Faydalı Model (Araştırma Raporlu)</label>
        </td>
        <td>
          <input
            type="radio"
            id="user"
            name="inventionType"
            value="faydalı model (araştırma Raporsuz)"
            [(ngModel)]="inventionType"
          />
          <label for="user">Faydalı Model (Araştırma Raporsuz)</label>
        </td>
      </tr>
    </table>
    <table>
      <tr>
        <td>
          <label for="priorityName">Buluşun İlgili Ülkedeki Adı:</label>
        </td>
        <td>
          <textarea
            rows="1"
            cols="150"
            [(ngModel)]="priorityName"
            (ngModelChange)="priorityName = $event.toLowerCase()"
            type="text"
            id="priorityName"
            placeholder="{{ priorityName }}"
          >
          </textarea>
        </td>
      </tr>

      <tr>
        <td>
          <label for="priorityNumber">Eklenecek Ülkedeki Patent No:</label>
        </td>
        <td>
          <textarea
            [(ngModel)]="priorityNumber"
            (ngModelChange)="priorityNumber = $event.toLowerCase()"
            rows="1"
            cols="150"
            type="text"
            id="priorityNumber"
            placeholder="{{ priorityNumber }}"
          ></textarea>
        </td>
      </tr>

      <tr>
        <td>
          <label for="priorityNumber"
            >Eklenecek Ülkedeki Patentin Başvuru Tarihi:</label
          >
        </td>
        <td>
          <input
            [(ngModel)]="priorityDate"
            type="date"
            id="priorityDate"
            placeholder="{{ priorityDate }}"
          />
        </td>
      </tr>
      <tr>
        <td>
          <label for="abstract">Buluş Özeti</label>
        </td>
        <td>
          <textarea
            [(ngModel)]="abstract"
            (ngModelChange)="abstract = $event.toLowerCase()"
            rows="3"
            cols="150"
            type="text"
            id="abstract"
            placeholder="{{ abstract }}"
          ></textarea>
        </td>
      </tr>
      <tr>
        <td>
          <label for="title">1.İstem</label>
        </td>
        <td>
          <textarea
            [(ngModel)]="firstClaim"
            (ngModelChange)="firstClaim = $event.toLowerCase()"
            rows="10"
            cols="150"
            type="text"
            id="title"
            name="title"
            placeholder="{{ firstClaim }}"
          ></textarea>
        </td>
      </tr>
      <tr>
        <td>
          <label for="title">Notlar</label>
        </td>
        <td>
          <textarea
            [(ngModel)]="countryNote"
            (ngModelChange)="countryNote = $event.toLowerCase()"
            rows="5"
            cols="150"
            type="text"
            id="title"
            name="title"
            placeholder="{{ countryNote }}"
          ></textarea>
        </td>
      </tr>
    </table>
    <p></p>
    <table>
      <tr>
        <td>
          <label for="priorityCountry">Eklenecek Başvuru Ülkesi:</label>
          <select
            name="priorityCountry"
            [(ngModel)]="priorityCountry"
            id="priorityCountry"
          >
            <option value="türkiye (tr)">Türkiye (TR)</option>
            <option value="pct (wipo)(pct)">PCT (WIPO)(PCT)</option>
            <option value="avrupa (epo)(ep)">Avrupa Patenti (EPO)(EP)</option>
            <option value="körfez işbirliği sözleşmesi (gcc)">
              Körfez İşbirliği Sözleşmesi (GCC)
            </option>
            <option value="avrasya patent sözleşmesi (eurasian)">
              Avrasya Patent Sözleşmesi (EURASIAN)
            </option>
            <option value="afrika fikri mülkiyet örgütü (oapi)">
              Afrika Fikri Mülkiyet Örgütü (OAPI)
            </option>
            <option value="afrika fikri mülkiyet örgütü (aripo)">
              Afrika Fikri Mülkiyet Örgütü (ARIPO)
            </option>
            <option value="amerika (us)">Amerika (US)</option>
            <option value="birleşik arap emirlikleri (bae)">
              Birleşik Arap Emirikleri (BAE)
            </option>
            <option value="antigua ve barbuda (ag)">
              Antigua ve Barbuda (AG)
            </option>
            <option value="arnavutluk (al)">Arnavutluk (AL)</option>
            <option value="ermenistan (am)">Ermenistan (AM)</option>
            <option value="angola (ao)">Angola (AO)</option>
            <option value="avusturya (at)">Avusturya (AT)</option>
            <option value="azerbeycan/azerbaycan (az)">Azerbeycan (AZ)</option>
            <option value="saraybosna/bosnahersek (ba)">SarayBosna (BA)</option>
            <option value="barbados (bb)">Barbados (BB)</option>
            <option value="belçika (be)">Belçika (BE)</option>
            <option value="burkina faso (BF)">Burkina Faso (BF)</option>
            <option value="bulgaristan (bg)">Bulgaristan (BG)</option>
            <option value="bahreyn (be)">Bahreyn (BE)</option>
            <option value="benin (bj)">Benin (BJ)</option>
            <option value="brezilya (br)">Brezilya (BR)</option>
            <option value="botsvana/botswana (bw)">Botsvana (BW)</option>
            <option value="belarus (by)">Belarus (BY)</option>
            <option value="belize (bz)">Belize (BZ)</option>
            <option value="kanada (ca)">Kanada (CA)</option>
            <option value="orta afrika cumhuriyeti (cf)">
              Orta Afrika Cumhuriyeti (CF)
            </option>
            <option value="isviçre (ch)">İsviçre (CH)</option>
            <option value="fildişi sahili (ci)">Fildişi Sahili (CI)</option>
            <option value="şili (cl)">Şili (CL)</option>
            <option value="kamerun (CM)">Kamerun (CM)</option>
            <option value="çin (cn)">Çin (CN)</option>
            <option value="kolombiya (co)">Kolombiya (CO)</option>
            <option value="kosta rika/kostarika (cr)">Kosta Rika (CR)</option>
            <option value="küba (cu)">Küba (CU)</option>
            <option value="kıbrıs (cy)">Kıbrıs (CY)</option>
            <option value="çek cumhuriyeti (cz)">Çek Cumhuriyeti (CZ)</option>
            <option value="almanya (de)">Almanya (DE)</option>
            <option value="cibuti (dj)">Cibuti (DJ)</option>
            <option value="danimarka (da)">Danimarka (DA)</option>
            <option value="dominik (dm)">Dominik (DM)</option>
            <option value="dominik cumhuriyeti (do)">
              Dominik Cumhuriyeti (DO)
            </option>
            <option value="cezayir (dz)">Cezayir (DZ)</option>
            <option value="ekvator (ec)">Ekvator (EC)</option>
            <option value="estonya (ee)">Estonya (EE)</option>
            <option value="mısır (eg)">Mısır (EG)</option>
            <option value="ispanya (es)">İspanya (ES)</option>
            <option value="finlandiya (fi)">Finlandiya (FI)</option>
            <option value="fransa (fr)">Fransa (FR)</option>
            <option value="gabon (ga)">Gabon (GA)</option>
            <option value="ingiltere krallığı (gb)">İngiltere (GB)</option>
            <option value="grenada (gd)">Grenada (GD)</option>
            <option value="Gürcistan (ge)">Gürcistan (GE)</option>
            <option value="gana (gh)">Gana (GH)</option>
            <option value="gambiya (gm)">Gambiya (GM)</option>
            <option value="gine (gn)">Gine (GN)</option>
            <option value="yunanistan (gr)">Yunanistan (GR)</option>
            <option value="guatemala (gn)">Guatemala (GN)</option>
            <option value="honduras (hn)">Honduras (HN)</option>
            <option value="hırvatistan (hr)">Hırvatistan (HR)</option>
            <option value="macaristan (hu)">Macaristan (hu)</option>
            <option value="endonezya (id)">Endonezya (ID)</option>
            <option value="irlanda (ie)">İrlanda (IE)</option>
            <option value="israil (il)">İsrail (IL)</option>
            <option value="hindistan (ie)">Hindistan (IE)</option>
            <option value="ırak (iq)">Irak (IQ)</option>
            <option value="iran (ir)">İran (IR)</option>
            <option value="izlanda (is)">İzlanda (IS)</option>
            <option value="italya (it)">İtalya (IT)</option>
            <option value="jamaika (jm)">Jamaika (JM)</option>
            <option value="ürdün (jo)">Ürdün (JO)</option>
            <option value="japonya (jp)">Japonya (JP)</option>
            <option value="kenya (ke)">Kenya (KE)</option>
            <option value="kırgizistan (kg)">Kırgızistan (kg)</option>
            <option value="kamboçya (kh)">Kamboçya (KH)</option>
            <option value="güney kore (kr)">Güney Kore (KR)</option>
            <option value="kuveyt (kw)">Kuveyt (KW)</option>
            <option value="kazakistan (kz)">Kazakistan (KZ)</option>
            <option value="lübnan (lb)">Lübnan (LB)</option>
            <option value="lihtenştayn (li)">Lihtenştayn (LI)</option>
            <option value="sri lanka/srilanka (lr)">Sri Lanka (LR)</option>
            <option value="liberya (lr)">Liberya (LR)</option>
            <option value="lesotho (ls)">Lesotho (LS)</option>
            <option value="litvanya (lt)">Litvanya (LT)</option>
            <option value="lüksemburg (lu)">Lüksemburg (LU)</option>
            <option value="letonya (lv)">Letonya (LV)</option>
            <option value="libya (ly)">Libya (LY)</option>
            <option value="fas (ma)">Fas (MA)</option>
            <option value="monaco (mc)">Monaco (MC)</option>
            <option value="moldova (md)">Moldova (MD)</option>
            <option value="karadağ (me)">Karadağ (ME)</option>
            <option value="madagaskar (md)">Madagaskar (MD)</option>
            <option value="makedonya (mk)">Makedonya (MK)</option>
            <option value="mali (me)">Mali (ME)</option>
            <option value="moğolistan (mn)">Moğolistan (MN)</option>
            <option value="moritanya (mr)">Moritanya (MR)</option>
            <option value="malta (mt)">Malta (MT)</option>
            <option value="meksika (mx)">Meksika (MX)</option>
            <option value="malezya (me)">Malezya (ME)</option>
            <option value="mozambik (mz)">Mozambik (MZ)</option>
            <option value="namibya (na)">Namibya (NA)</option>
            <option value="nijer (ne)">Nijer (NE)</option>
            <option value="nijerya (ng)">Nijerya (NG)</option>
            <option value="nikeragua (ni)">Nikeragua (NI)</option>
            <option value="hollanda (nl)">Hollanda (NL)</option>
            <option value="norveç (no)">Norveç (NO)</option>
            <option value="yeni zelanda (nz)">Yeni Zelanda (NZ)</option>
            <option value="umman (om)">Umman (OM)</option>
            <option value="panama (pa)">Panama (PA)</option>
            <option value="peru (pe)">Peru (PE)</option>
            <option value="papua yeni gine (pg)">Papua Yeni Gine (PG)</option>
            <option value="filipinler (PH)">Filipinler (PH)</option>
            <option value="polonya (pl)">Polonya (PL)</option>
            <option value="portekiz (pt)">Portekiz (PT)</option>
            <option value="katar (qa)">Katar (QA)</option>
            <option value="romanya (ro)">Romanya (RO)</option>
            <option value="sırbistan (rs)">Sırbistan (RS)</option>
            <option value="rusya (ru)">Rusya (RU)</option>
            <option value="suudi arabistan (sa)">Suudi Arabistan (SA)</option>
            <option value="sudan (sd)">Sudan (SD)</option>
            <option value="isveç (se)">İsveç (SE)</option>
            <option value="singapur (sg)">Singapur (SG)</option>
            <option value="slovenya (si)">Slovenya (SI)</option>
            <option value="slovakya (sk)">Slovakya (SK)</option>
            <option value="san marino (sm)">San Marino (SM)</option>
            <option value="senegal (sn)">Senegal (SN)</option>
            <option value="el salvador/elsalvador (sv)">
              El Salvador (SV)
            </option>
            <option value="suriye (sy)">Suriye (SY)</option>
            <option value="çad (td)">Çad (TD)</option>
            <option value="togo (tg)">Togo (TG)</option>
            <option value="tayland (th)">Tayland (TH)</option>
            <option value="tacikistan (tj)">Tacikistan (TJ)</option>
            <option value="türkmenistan (tm)">Türkmenistan (TM)</option>
            <option value="tunus (tn)">Tunus (TN)</option>
            <option value="trinidad ve tobago (tt)">
              Trinidad ve Tobago (TT)
            </option>
            <option value="tanzanya (tz)">Tanzanya (TZ)</option>
            <option value="ukrayna (ua)">Ukrayna (UA)</option>
            <option value="angola (ao)">Uganda (UG)</option>
            <option value="amerika (us)">Amerika (US)</option>
            <option value="özbekistan (uz)">Özbekistan (UZ)</option>
            <option value="vietnam (vn)">Vietnam (VN)</option>
            <option value="güney afrika (za)">Güney Afrika (ZA)</option>
            <option value="zambiya (zm)">Zambiya (ZM)</option>
            <option value="zimbabve (zw)">Zimbabve (ZW)</option>
          </select>
        </td>
        <!-- <td>
          <input
            type="radio"
            id="user"
            name="user"
            value="Türkiye"
            [(ngModel)]="priorityCountry"
          />

          <label for="user">Türkiye (TR)</label>
        </td>

        <td>
          <input
            type="radio"
            id="user"
            name="user"
            value="PCT Başvurusu"
            [(ngModel)]="priorityCountry"
          />
          <label for="user">WIPO/PCT (WO)</label>
        </td>
        <td>
          <input
            type="radio"
            id="user"
            name="user"
            value="Avrupa Patenti / EPO"
            [(ngModel)]="priorityCountry"
          />
          <label for="user">EPO (EP)</label>
        </td>
        <td>
          <button class="btn btn-warning" (click)="showCountries()">
            Ülkem farklı
          </button>
          <ng-container *ngIf="visibleCountryList">
            <input type="text" [(ngModel)]="priorityCountry" />
          </ng-container>
        </td> -->
      </tr>
    </table>
    <ng-container *ngIf="visibleCountryList">
      <input type="text" [(ngModel)]="priorityCountry"
      (ngModelChange)="priorityCountry=$event.toLowerCase()" />
    </ng-container>
    <p></p>
    <button
      [disabled]="
        priorityCountry === 'ülke seçilmedi' ||
        priorityNumber == '' ||
        priorityName == '' ||
        priorityDate == ''
      "
      class="btn"
      (click)="recordEnterance()"
      style="
        margin-left: auto;
        margin-right: 10%;
        font-size: 18px;
        display: block;
        background-color: #28384f;
      "
    >
      Ülke Girişini Kaydet
    </button>
  </div>
</div>
